import type { IWorkJourneyManagementUser } from '@src/models/interfaces/workJourneyManagement.interface';
import UserService from '@src/services/UserService';

import { formatCoverUserDisplayName } from './formatCoverUserDisplayName';

const userService = new UserService();

/**
 * Hydrates cover-drawer absent/replaced rows when attention details only carry
 * a corrupt or missing displayName. Firestore stays in UserRepository.
 */
export const loadOrganizationUsersByIds = async (
  organizationId: string,
  userIds: string[],
): Promise<Map<string, IWorkJourneyManagementUser>> => {
  const byId = new Map<string, IWorkJourneyManagementUser>();
  const profiles = await userService.getOrganizationUsersByIds(organizationId, userIds);
  (profiles ?? []).forEach(profile => {
    const firstName = profile.firstName ?? '';
    const lastName = profile.lastName ?? '';
    byId.set(profile.id, {
      id: profile.id,
      displayName: formatCoverUserDisplayName({
        id: profile.id,
        displayName: profile.displayName,
        firstName,
        lastName,
      }),
      email: profile.email ?? '',
      firstName,
      lastName,
      idCard: profile.idCard ?? '',
    });
  });

  return byId;
};
